import "../../../styles/kjedeweb/singleChainProductListItem.scss";

import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";

export class HubOverviewListHeader extends React.PureComponent {
    render() {
        const {
            localization,
            customers,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "22%"}}>
                            <ResponsiveRows gutters={false} >
                                <ResponsiveColumn lg={7}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("hub", "overview", "description")}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={5}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("hub", "overview", "plannedQty")}
                                    </div>
                                </ResponsiveColumn>                                
                            </ResponsiveRows>
                        </div>
                        <div style={{  flexBasis: "72%", display:"flex"}}>
                            {customers.map((cus,idx) => (                                    
                                <div key={idx}  className="product-view-list-header" style={{ width: "100%"}}>
                                    {cus.departmentStoreNo}
                                </div>
                            ))}
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    }
}

HubOverviewListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
    customers: PropTypes.array.isRequired,
};

export class HubOverviewListItem extends React.PureComponent {
    constructor(props) {
        super(props);

    }

    render() {
        const {
            product,
            style,
        } = this.props;

        return (
            <div className="product-view-list-item-wrapper not-interactive" style={style}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "22%"}}>
                            <ResponsiveRows gutters={false}>
                                <ResponsiveColumn lg={8}>
                                    <div className="label14 product-view-list-item-prd-info_multiline_narrow" style={{ display: "flex", alignItems: "center"}}>
                                        <div style={{ width: "100%" }}>
                                            {product.productName}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={4}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {product.qtyToBeProduced}
                                        </div>
                                    </div>
                                </ResponsiveColumn>               
                            </ResponsiveRows>
                        </div>
                        <div style={{ flexBasis: "72%", display:"flex" }}>
                            {product.customers.map((cus,idx) => (        
                                <div key={idx} className="label14 product-view-list-item">
                                    {cus.qtyToBeProduced}
                                </div>
                            ))} 
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HubOverviewListItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object,
    style: PropTypes.object,
};

HubOverviewListItem.defaultProps = {
};